import React, { useEffect, useState } from "react";
import axios from "axios";
import { MdStars } from "react-icons/md";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

interface UserStructure {
  profile: string;
  id: number;
  name: string;
  email: string;
  role: string;
  designation: string;
  company_name: string;
  Facebook: string;
  Linkedin: string;
  point: number;
  number: number;
}

const TopHerosection = () => {
  const api = process.env.REACT_APP_API_URL as string;
  const [users, setUsers] = useState<UserStructure[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get<UserStructure[]>(`${api}/auth/allusersinfo`);
        const sorted = response.data
          .filter(user => user.role !== "super-admin")
          .sort((a, b) => b.point - a.point)
          .slice(0, 5);
        setUsers(sorted);
      } catch (error) {
        console.error("Failed to fetch users:", error);
      }
    };
    fetchData();
  }, [api]);

  const getMedalColor = (index: number) => {
    switch (index) {
      case 0:
        return "bg-[#FFD700] text-black"; // Gold
      case 1:
        return "bg-[#C0C0C0] text-black"; // Silver
      case 2:
        return "bg-[#CD7F32] text-white"; // Bronze
      default:
        return "bg-[#FDBC12] text-black"; // Others
    }
  };

  return (
    <section className="bg-gradient-to-b from-[#0D1724] to-[#1E2A3A] py-20 px-6 sm:px-10 lg:px-20">
      <div className="max-w-7xl mx-auto text-center mb-12">
        <h2 className="text-4xl font-bold text-white">
          Top <span className="text-[#FDBC12]">RMBians </span> of the Month
        </h2>
        <p className="text-gray-400 mt-2 text-lg">
          Celebrating the most active contributors in the community.
        </p>
      </div>

      {/* Slider on mobile, grid on lg+ */}
      <div className="block lg:hidden">
        <Swiper
          modules={[Pagination]}
          spaceBetween={20}
          pagination={{ clickable: true }}
          slidesPerView={1}
        >
          {users.map((user, index) => (
            <SwiperSlide key={user.id}>
              <div className="relative bg-[#101729] p-6 rounded-xl shadow-lg text-center">
                {/* Rank Badge */}
                <div
                  className={`absolute top-4 left-4 px-3 py-1 rounded-full text-xs font-bold ${getMedalColor(
                    index
                  )}`}
                >
                  #{index + 1}
                </div>

                {/* Profile Image */}
                <div className="w-24 h-24 mx-auto rounded-full overflow-hidden border-4 border-[#FDBC12] mb-4">
                  <img
                    src={`${api}/${user.profile}`}
                    alt={user.name}
                    className="w-full h-full object-cover"
                  />
                </div>

                {/* User Info */}
                <h3 className="text-white text-lg font-semibold">{user.name}</h3>
                <p className="text-sm text-[#FDBC12] mt-1 font-medium">{user.role}</p>
                <p className="text-sm text-gray-400">{user.designation}</p>

                {/* Points */}
                <div className="flex justify-center items-center gap-1 text-sm text-white mt-3">
                  <MdStars className="text-yellow-400" />
                  <span>{user.point} Points</span>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* Grid on lg and above */}
     <div className="hidden lg:grid grid-cols-3 xl:grid-cols-5 gap-8">
  {users.map((user, index) => (
    <div
      key={user.id}
      className="relative bg-[#101729] min-h-[380px] py-8 p-6 rounded-xl shadow-lg hover:shadow-2xl hover:-translate-y-1 transition-all duration-300 text-center flex flex-col justify-between"
    >
      {/* Badge */}
      <div
        className={`absolute top-4 left-4 px-3 py-1 rounded-full text-xs font-bold ${getMedalColor(
          index
        )}`}
      >
        #{index + 1}
      </div>

      {/* Avatar */}
      <div className="w-24 h-24 mx-auto rounded-full overflow-hidden border-4 border-[#FDBC12] mb-4">
        <img
          src={`${api}/${user.profile}`}
          alt={user.name}
          className="w-full h-full object-cover"
        />
      </div>

      {/* Text Content */}
      <div className="flex flex-col gap-2 px-2">
        <h3 className="text-white text-lg font-semibold line-clamp-2 block">{user.name}</h3>
        <p className="text-sm text-[#FDBC12] font-medium">{user.role}</p>
      <p className="text-sm text-gray-400 line-clamp-2 min-h-[2.5rem]">{user.designation}</p>
      </div>

      {/* Points */}
      <div className="flex justify-center items-center gap-1 text-sm text-white mt-4">
        <MdStars className="text-yellow-400" />
        <span>{user.point} Points</span>
      </div>
    </div>
  ))}
</div>

    </section>
  );
};

export default TopHerosection;
